// extracted by mini-css-extract-plugin
export default {"cont":"EndNode_cont__d4UD-","details":"EndNode_details__ptj5x","placeholder":"EndNode_placeholder__jRTiE","text":"EndNode_text__S2VRG"};